// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../node_modules/postcss-loader/src/index.js!../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._3y93Mz0xx{flex-direction:column;justify-content:center;flex-grow:1;text-align:center;padding:20px}._44310Svbx{align-items:center}._2HYu663Xx{justify-content:center}._1F1slkYdx{}._5yUnvtNTx{flex:0 0 100%}._6Ee7OI7wx{align-items:stretch}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_3y93Mz0xx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"vertically-center": "_44310Svbx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"verticallyCenter": "_44310Svbx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"horizontally-center": "_2HYu663Xx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"horizontallyCenter": "_2HYu663Xx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"centered": "_1F1slkYdx _44310Svbx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + " _2HYu663Xx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"full-flex-basis": "_5yUnvtNTx",
	"fullFlexBasis": "_5yUnvtNTx",
	"flex-stretch": "_6Ee7OI7wx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + "",
	"flexStretch": "_6Ee7OI7wx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["flex"] + ""
};
module.exports = exports;
